<aside class="site_sidebar" [ngClass]="{ collapsed: collapsed() }">
  <!-- Toggle -->
  <button class="toggle_btn" (click)="toggleSidebar()" [pTooltip]="collapsed() ? 'Expand' : 'Collapse'"
    tooltipPosition="right">
    <i class="pi pi-bars"></i>
  </button>

  <!-- Logo -->
  <div class="logo_box hd_4" (click)="navigate('/dashboard')" style="cursor: pointer">
    <figure class="site_logo">
      @if (appConfig()?.company_logo) {
      <img [src]="appConfig()!.company_logo" alt="Logo" class="sidebar_logo_img" />
      } @else {
      <figcaption>
        {{ (appConfig()?.platform_name | slice: 0 : 1) || "Q" }}
      </figcaption>
      }
    </figure>
    @let portalText =
    role === "admin"
    ? "Admin"
    : role === "sales"
    ? "Sales"
    : role === "ba"
    ? "Business Analyst"
    : role === "approver"
    ? "Approver"
    : "Marketing";
    @if (!collapsed() || !isLargeScreen()) {
    <h2>
      <strong>{{ appConfig()?.platform_name || "Aptunix Quote Hub" }}</strong>
      <span>{{ portalText }} Portal </span>
    </h2>
    }
  </div>

  <!-- NAV -->
  <ul class="side_nav">
    @for (item of visibleMenu; track item.label) {
    <li routerLinkActive="active" [routerLinkActiveOptions]="{
          paths: 'exact',
          queryParams: 'ignored',
          matrixParams: 'ignored',
          fragment: 'ignored',
        }" [ngClass]="{
          has_submenu: item.children,
          expanded: expandedMenus()[item.label],
        }">
      <!-- SIMPLE LINK -->
      @if (!item.children) {
      <a [routerLink]="item.route" (click)="closeSidebarOnMobile()" pRipple [pTooltip]="item.tooltip"
        [tooltipDisabled]="!collapsed()" tooltipPosition="right">
        <span [class]="item.icon"></span>

        @if (!collapsed() || !isLargeScreen()) {
        <span class="nav_label">{{ item.label }}</span>
        @if (item.label === "News") {
        <!-- <span class="live_dot"></span> -->
        <div class="live-badge"><span class="live_dot"></span>Live</div>
        }
        }
      </a>
      }

      <!-- SUBMENU -->
      @if (item.children) {
      <a href="javascript:;" (click)="toggleSubmenu(item.label)" pRipple [pTooltip]="item.tooltip"
        [tooltipDisabled]="!collapsed()" tooltipPosition="right">
        <span [class]="item.icon"></span>

        @if (!collapsed() || !isLargeScreen()) {
        <span class="nav_label">{{ item.label }}</span>
        }

        <i class="pi pi-chevron-down submenu_icon"></i>
      </a>

      @if (expandedMenus()[item.label]) {
      <ul class="submenu">
        @for (sub of item.children; track sub.label) {
        <li routerLinkActive="active" [routerLinkActiveOptions]="{
                    paths: 'exact',
                    queryParams: 'ignored',
                    matrixParams: 'ignored',
                    fragment: 'ignored',
                  }">
          <a [routerLink]="sub.route" (click)="closeSidebarOnMobile()" pRipple [pTooltip]="sub.tooltip"
            [tooltipDisabled]="!collapsed()" tooltipPosition="right">
            <span [class]="sub.icon"></span>
            @if (!collapsed() || !isLargeScreen()) {
            <span class="nav_label">{{ sub.label }}</span>
            }
          </a>
        </li>
        }
      </ul>
      }
      }
    </li>
    }
  </ul>
</aside>

<div class="aside_overlay" (click)="toggleSidebar()"></div>